module.exports = __webpack_public_path__ + "static/media/fab-mail.fa3173fc.svg";